<template>
  <div class="footer-wrapper">
    <div class="footer-btm">
      <div class="footer-left">
        <img :src="maerskLogo" alt="Maersk logo" />
        <span class="footer-logo-text">{{ $t("footer.footerText") }}</span>
      </div>
      <div class="footer-links">
        <a :href="DOMPurify.sanitize($t(`footer.contactUs`))" rel="noopener noreferrer">{{ $t("footer.contact") }}</a>
        <a :href="DOMPurify.sanitize($t(`footer.contactLegalTeam`))" rel="noopener noreferrer">
          {{ $t("footer.faq") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useGlobals } from "@/utils/globals";
import DOMPurify from "dompurify";

const { $t } = useGlobals();
const maerskLogo = ref("/assets/images/Logo.svg");
</script>

<style scoped>
@import "@/scss/layout/_footer.scss";
</style>
